export default {
  Manager: 'API.Scheduling.Manager',
  Partner: 'API.Scheduling.Partner',
  CoManager: 'API.Scheduling.CoManager',
  Admin: 'API.Scheduling.Admin',
  Allocation: 'API.Scheduling.Allocation',
  TechLab: 'API.Scheduling.TechLab',
  ReadAll: 'API.Scheduling.Read',
};
